module.exports = __webpack_public_path__ + "img/4.a9defe1.png";